import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SORT_OPTIONS } from "../../data/catalog";
import useBrowseState from "../../hooks/useBrowseState";
import { shopPath } from "../../routes";

export default function SortSelect() {
  const navigate = useNavigate();
  const { department, subcategory, size, sort } = useBrowseState();
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const label = option => option.label.replace(/^Sort: /, "");
  const selected = SORT_OPTIONS.find(option => option.value === sort);
  const close = () => { setOpen(false); trigger.current?.focus(); };
  useEffect(() => {
    if (!open) return undefined;
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("pointerdown", outside);
    root.current?.querySelector('[aria-selected="true"]')?.focus();
    return () => document.removeEventListener("pointerdown", outside);
  }, [open]);
  return <div className="browsebar"><div className="v125Toolbar">
    <div className="v176SortPanel compactSort" ref={root} onKeyDown={event => {
      if (event.key === "Escape") { event.preventDefault(); close(); }
      if (open && ["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
        event.preventDefault();
        const options = [...root.current.querySelectorAll('[role="option"]')];
        const index = options.indexOf(document.activeElement);
        const next = event.key === "Home" ? 0 : event.key === "End" ? options.length - 1 : (index + (event.key === "ArrowDown" ? 1 : -1) + options.length) % options.length;
        options[next]?.focus();
      }
    }}>
      <span className="productSortLabel">Sort by:</span>
      <button type="button" ref={trigger} className="compactSortTrigger" aria-label={`Sort products: ${label(selected)}`} aria-haspopup="listbox" aria-expanded={open}
        onClick={() => setOpen(!open)} onKeyDown={event => { if (event.key === "ArrowDown") { event.preventDefault(); setOpen(true); } }}>
        <span>{label(selected)}</span><span className={`compactSortChevron${open ? " expanded" : ""}`} aria-hidden="true" />
      </button>
      {open && <div className="compactSortMenu" role="listbox" aria-label="Sort products">
        {SORT_OPTIONS.map(option => <button type="button" role="option" aria-selected={option.value === sort} key={option.value}
          onClick={() => { navigate(shopPath({ department, subcategory, size, sort: option.value })); close(); }}>
          <span className="compactSortDot" aria-hidden="true">{option.value === sort ? "•" : ""}</span>{label(option)}
        </button>)}
      </div>}
    </div>
  </div></div>;
}
